@if (value()) {
  <app-advertising-form
    [(value)]="value"
    [edit]="false"
    [create]="false"
    [delete]="false"
    [details]="true"
    [access]="access()"
  ></app-advertising-form>
}
